import { ref, reactive, computed } from 'vue'
import { BleClient } from '@capacitor-community/bluetooth-le'
export const PFC_SERVICE = '6217ff4b-fb31-1140-ad5a-a45545d7ecf3'
export const CHARACTERISTIC_CONFIGURATION = '6217ff4d-91bb-91d0-7e2a-7cd3bda8a1f3' //PFC_CP_CHARACTERISTIC
export const CHARACTERISTIC_FEATURE = '6217ff4c-c8ec-b1fb-1380-3ad986708e2d' // a priori on lance en fesant un "read" et il envoi toutes les informations des features
//TBD4 PFC / Polar Features Configuration     // /* Polar Features Configuration Service (PFCS)*/
export default class PolarFeaturesConfiguration {
    // private properties
    promises = { configuration: null }
    configurationQueue = Promise.resolve()
    notificationsStarted = false

    features = reactive({
        'BROADCAST': { request: 2, configure: 1, value: null },
        '5KHZ': { request: 4, configure: 3, value: null },
        'WHISPER_MODE': { request: 6, configure: 5, value: null },
        'BLE_MODE': { request: null, configure: 7, value: null },
        'MULTI_CONNECTION': { request: 9, configure: 8, value: null },
        'ANT_PLUS': { request: 11, configure: 10, value: null },
    })
    device = null
    // static UNKNOWN = 0

    constructor(device) {
        this.device = device
    }

    resolveConfiguration(value) {
        const pending = this.promises.configuration
        this.promises.configuration = null
        pending?.resolve(value)
    }

    rejectConfiguration(error) {
        const pending = this.promises.configuration
        this.promises.configuration = null
        pending?.reject(error)
    }

    async queueConfigurationRequest(factory) {
        const runRequest = async () => {
            const promise = new Promise((resolve, reject) => {
                this.promises.configuration = { resolve, reject }
            })

            try {
                await factory()
            } catch (error) {
                this.rejectConfiguration(error)
            }

            return promise
        }

        const queuedRequest = this.configurationQueue.then(runRequest, runRequest)
        this.configurationQueue = queuedRequest.catch(() => {})
        return queuedRequest
    }

    async start() {
        //multi mode https://github.com/polarofficial/polar-ble-sdk/blob/master/sources/Android/android-communications/library/src/main/java/com/polar/androidcommunications/api/ble/model/gatt/client/BlePfcClient.java

        if (this.notificationsStarted) {
            return
        }

        await BleClient.startNotifications(this.device.deviceId, PFC_SERVICE, CHARACTERISTIC_CONFIGURATION, (value) => {
            console.log('PFC characteristicvaluechanged value', value)
            const status = value.getUint8(2)
            const feature = value.getUint8(1)
            if (!this.promises.configuration) {
                console.warn('PFC response received without a pending request', { status, feature })
                return
            }
            if (status === 1) {
                this.resolveConfiguration(value.byteLength === 4 && value.getUint8(3))
            } else {
                this.rejectConfiguration(new Error('Fail!'))
            }
        })
        this.notificationsStarted = true

        // await this.read('BROADCAST')
        // await this.read('5KHZ')
        // await this.read('WHISPER_MODE')
        await this.read('MULTI_CONNECTION')
        // await this.read('ANT_PLUS')
        // console.log('OK READ')
    }

    async stop() {
        this.rejectConfiguration(new Error('PFC stopped'))
        this.configurationQueue = Promise.resolve()

        if (!this.notificationsStarted || !this.device?.deviceId) {
            return
        }

        try {
            await BleClient.stopNotifications(this.device.deviceId, PFC_SERVICE, CHARACTERISTIC_CONFIGURATION)
        } catch (error) {
            console.warn('[Polar PFC] Failed to stop notifications', error)
        } finally {
            this.notificationsStarted = false
        }
    }

    async read(key) {
        const val = await this.getConfiguration(this.features[key].request)
        this.features[key].value = val
        return this.features[key].value
    }

    async toggle(key) {
        if (!this.features?.[key]) {
            throw new Error(`key ${key} does not exist`)
        }
        if (this.features[key].value === 0) {
            await this.setConfiguration(this.features[key].configure, 1)
        } else {
            await this.setConfiguration(this.features[key].configure, 0)
        }
        return await this.read(key)
    }

    async setEnabled(key, enabled = true) {
        if (!this.features?.[key]) {
            throw new Error(`key ${key} does not exist`)
        }

        const nextValue = enabled ? 1 : 0
        const currentValue = await this.read(key)

        if (currentValue === nextValue) {
            return currentValue
        }

        await this.setConfiguration(this.features[key].configure, nextValue)
        return await this.read(key)
    }

    async getConfiguration(id) {
        return this.queueConfigurationRequest(() =>
            BleClient.writeWithoutResponse(
                this.device.deviceId,
                PFC_SERVICE,
                CHARACTERISTIC_CONFIGURATION,
                Uint8Array.of(id)
            )
        )
    }

    async setConfiguration(id, value) {
        return this.queueConfigurationRequest(() =>
            BleClient.writeWithoutResponse(
                this.device.deviceId,
                PFC_SERVICE,
                CHARACTERISTIC_CONFIGURATION,
                Uint8Array.of(id, value)
            )
        )
    }
}
